import styled from "styled-components";
import theme from "../../../Styles/theme";

export const Container = styled.div``;

export const Title = styled.h5`
    color: ${theme.colors.dark};
    font-size: max(1.5vw,18px);
    font-weight:bold;
`;

export const Message = styled.div`
 color: ${theme.colors.dark};
    font-size: max(1.2vw,15px);
`;